export const resend_verify_code_for_user_attributes = (user) => {
    return new Promise((resolve, reject) => {
        user.getAttributeVerificationCode("email", {
            onSuccess() {
                return resolve();
            },
            onFailure(err) {
                return reject(err);
            }
        });
    })
};
